import constants from '../../../qti/Constants';
import globalsService from '../../../services/GlobalsService';

/**
 * Loader for Symbolic Math resources.
 * Defines the files needed for the Symbolic Math interaction to work offline.
 */
const SymbolicMathLoader = {
    /**
     * Gets all files that need to be cached for Symbolic Math.
     * @returns {Array} - An array of file objects with url and type.
     */
    getAllFilesToCache() {
        const assetRoot = globalsService.getAssetRoot();
        return [
            { url: `${assetRoot}/lazy-math-keyboard.chunk.js`, type: 'js' },
            { url: `${constants.staticLibPaths.MATHJAX3}tex-chtml.js`, type: 'js' },
            { url: `${constants.staticLibPaths.MATHJAX3}output/chtml/fonts/woff-v2/MathJax_Zero.woff`, type: 'font' },
            { url: `${constants.staticLibPaths.MATHJAX3}output/chtml/fonts/woff-v2/MathJax_Main-Regular.woff`, type: 'font' },
            { url: `${assetRoot}/fonts/Symbola.woff2`, type: 'font' },
            { url: `${assetRoot}/fonts/Symbola.ttf`, type: 'font' },
            { url: `${assetRoot}/fonts/Symbola.otf`, type: 'font' },
            { url: `${assetRoot}/fonts/Symbola.eot`, type: 'font' },
        ];
    },
};

export default SymbolicMathLoader;
